// Source-level (DOM-free) transformations of the composition HTML for natural text editing.

function escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function escapeHtmlText(value: string): string {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

// Newlines become `<br>` so the raster reflows the same way the editor overlay does.
export function editableValueToHtml(value: string): string {
    return escapeHtmlText(value).replace(/\r\n|\r|\n/g, '<br>');
}

/**
 * Replace the text content of the element with the given `id` with `value`, escaped as plain text.
 * A targeted edit — the open tag and the rest of the document are preserved. Throws on a missing id.
 */
export function replaceEditableText(html: string, id: string, value: string): string {
    const escapedId = escapeRegExp(id);
    const element = new RegExp(
        `(<([a-zA-Z][\\w-]*)\\b[^>]*\\bid\\s*=\\s*(?:"${escapedId}"|'${escapedId}')[^>]*>)[\\s\\S]*?(</\\2>)`,
        'i',
    );
    if (!element.test(html)) {
        throw new Error(`replaceEditableText: no element with id="${id}"`);
    }
    return html.replace(element, (_match, openTag, _tagName, closeTag) => {
        return `${openTag}${editableValueToHtml(value)}${closeTag}`;
    });
}
